var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0846094 4.58067C0.144281 4.50903 0.229164 4.45835 0.323351 4.44025L23.5141 0.00734054C23.7335 -0.0336439 23.9461 0.101076 23.9932 0.309531C24.008 0.389633 23.9993 0.475619 23.9612 0.549614L13.7956 20.7797C13.697 20.9715 13.4556 21.0542 13.2549 20.9626C13.1697 20.9254 13.1014 20.8562 13.0617 20.773L9.28917 12.8365C9.23053 12.7187 9.24319 12.5808 9.31872 12.47L11.4688 9.33263L7.73759 10.5567C7.60774 10.6013 7.46358 10.578 7.35521 10.4973L0.153256 5.11732C0.0695103 5.05446 0.0155782 4.96321 0.00292343 4.86262C-0.00971758 4.76207 0.0188419 4.66044 0.0846094 4.58067ZM7.87435 8.68758L15.3291 6.23861C15.4361 6.20491 15.551 6.25745 15.5885 6.35746C15.6099 6.41459 15.5992 6.47668 15.5658 6.52576L11.2648 12.7996L13.4641 17.4253L21.0987 2.23128L3.68727 5.5592L7.87435 8.68758Z",
    fill: "url(#paint0_linear_1682_5178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1682_5178",
    x1: 12,
    y1: -1.46572e-8,
    x2: 12,
    y2: 40.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C244E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67DFFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.90922455a4cfadff238c9c6d2fd68abd.svg";
export { ForwardRef as ReactComponent };